export default {
  fieldsWrapper: {
    padding: '16px 24px 0 24px',
    overflowY: 'scroll',
    flex: '1 1 auto',
    maxHeight: `calc(100vh - 200px)`,
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '20px',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  mapContainer: {
    width: '100%',
    maxWidth: '600px',
  },
  formContainer: {
    width: '100%',
  },
  editButton: {
    color: (theme) => theme.palette.blues.primaryBlue500,
    p: 0.5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    padding: '0',
    ':hover': {
      '.MuiSvgIcon-root': {
        color: (theme) => theme.palette.blues.primaryBlue500,
      },
    },
    '.MuiSvgIcon-root': {
      width: '16px',
      height: '16px',
    },
    '&.Mui-disabled': {
      opacity: '0.3',
    },
  },
};
